module.exports = __webpack_public_path__ + "static/media/tuning-tools.d2b8b987.svg";